import styled from '@emotion/styled';

import { colours, gutter } from '../../../app/styles/constants';

export default styled.hr`
  border: 1px dashed ${colours.border};
  height: 0;
  margin: ${gutter} -${gutter};
`;
